<template>
  <div class="container-custom" v-if="projectDetail">
    <!-- breadscrumbs -->
    <div class="breadscrumbs">
      <router-link to="/csr-page" class="breadscrumbs-item"
        >ESG Page</router-link
      >
      <v-icon>chevron_right</v-icon>
      <router-link to="/csr-page/edit" class="breadscrumbs-item"
        >Edit</router-link
      >
      <v-icon>chevron_right</v-icon>
      <a class="breadscrumbs-item active">ESG Project Showcase Edit</a>
    </div>
    <!-- page-actions -->
    <div class="page-actions">
      <h2>編輯 ESG Page</h2>
      <v-spacer></v-spacer>
      <button class="btn mr-5" @click="cancelHandler">
        <span>取消</span>
      </button>
      <button class="btn btn-primary" @click="saveHandler">
        <span>儲存</span>
      </button>
    </div>

    <!-- block -->
    <div class="block mb-5">
      <!-- ProjectTitle -->
      <div class="form-item pt-5 d-flex">
        <label class="w-240px mr-5"
          ><h4>Project Title</h4>
        </label>
        <div class="my-n2 flex-grow-1">
          <v-text-field
            v-model="projectDetail.title"
            outlined
            dense
          ></v-text-field>
        </div>
      </div>
      <!-- Tab -->
      <div class="form-item pt-5 d-flex">
        <label class="w-240px mr-5"><h4>Tab</h4></label>
        <div class="my-n2 flex-grow-1">
          <v-autocomplete
            v-model="projectDetail.csr_project_filter_id"
            class="w-240px"
            :items="tabs"
            item-text="title"
            item-value="id"
            outlined
            dense
          >
          </v-autocomplete>
        </div>
      </div>
      <!-- img uploader -->
      <div class="form-item d-flex px-5 py-5">
        <div class="w-240px mr-5">
          <h4 class="mb-10px">Project Image</h4>
          <div class="h5 ink-02-medium--text">
            呈現於ESG Page <br />
            建議尺寸：500px*475px <br />
            檔案大小限制：≤20MB <br />
            支援格式：.png/.jpg/.gif
          </div>
        </div>
        <div class="d-flex flex-grow-1">
          <ImgUploader
            :imageUrl.sync="projectDetail.image"
            dir="csr"></ImgUploader>
        </div>
      </div>
      <!-- 顯示在首頁 -->
      <div class="form-item d-flex py-5">
          <div class="w-240px mr-5">
              <h4>顯示在首頁</h4>
          </div>
          <div class="flex-grow-1 flex-basis-0">
              <v-checkbox v-model="projectDetail.show_on_homepage">
              <template v-slot:label>
                  <div class="h5 ink-01-emphasis--text">
                  設定為顯示在首頁
                  </div>
              </template>
              </v-checkbox>
          </div>
      </div>
      <!-- Description -->
      <div class="form-item pt-5 d-flex">
        <label class="w-240px mr-5"
          ><h4>Project Outlined</h4>
        </label>
        <div class="my-n2 flex-grow-1">
          <v-textarea
            v-model="projectDetail.description"
            outlined
            dense
          ></v-textarea>
        </div>
      </div>
    </div>

    <!-- projectFilterCreater -->
    <ProjectFilterCreater
      :isShow="isProjectFilterCreaterShow"
      @close-creater="isProjectFilterCreaterShow = false"
    ></ProjectFilterCreater>

    <div class="page-divider mb-5"></div>

    <!-- content -->
    <div class="d-flex">
      <!-- content head -->
      <div class="w-300px mr-5">
        <h3 class="mb-10px">Content</h3>
        <div class="h4">
          至少需填寫一組 <br />
          於前台左圖右字、右圖左字交錯排版
        </div>
      </div>
      <div class="flex-grow-1">
        <!-- content body -->
        <div class="block mb-5" v-for="(item, i) in projectDetail.content" :key="i">
          <!-- content -->
          <div
            class="form-item py-5 d-flex align-center justify-lg-space-between"
          >
            <h4>Content</h4>
            <button
              v-if="i > 0"
              class="btn btn-danger square w-32px h-32px"
              @click="deleteItem(item)"
            >
              <v-icon color="white">delete</v-icon>
            </button>
          </div>
          <!-- Title -->
          <label class="form-item d-flex pt-5">
            <h4 class="w-160px mr-5">Title</h4>
            <div class="my-n2 flex-grow-1">
              <v-text-field
                v-model="item.title"
                outlined
                dense
              ></v-text-field>
            </div>
          </label>
          <!-- Description -->
          <label class="form-item d-flex py-5">
            <h4 class="w-160px mr-5">Description</h4>
            <div class="my-n2 flex-grow-1">
              <v-textarea
                v-model="item.description"
                outlined
                dense
              ></v-textarea>
            </div>
          </label>
          <!-- img uploader -->
          <div class="form-item d-flex px-5 py-5">
            <div class="w-180px">
              <h4 class="mb-10px">Visual</h4>
              <div class="h5 ink-02-medium--text">
                建議尺寸：999px * 999px <br />
                檔案大小限制：&lt; 1 MB
              </div>
            </div>
            <div class="d-flex justify-end flex-grow-1">
              <ImgUploader
                :imageUrl.sync="item.visual"
                dir="csr"></ImgUploader>
            </div>
          </div>
        </div>
        <!-- add Content Section -->
        <div class="mt-5 mb-9">
          <button class="btn btn-outlined w-100 justify-start" @click="addItem">
            <v-icon class="primary--text mr-2">add_circle</v-icon>
            <span>添加Content Section</span>
          </button>
        </div>
        </div>
    </div>

    <div class="page-divider my-5"></div>
    <!-- downloads -->
    <div class="d-flex">
      <h3 class="w-300px mr-5">Downloads</h3>
      <div class="pa-5 block flex-grow-1 flex-basis-0">
        <div>
          <h3 class="mb-5">Downloads(全語系共用, 刪除時所有語系會同步刪除)</h3>
          <div class="h4 mb-5">
            顯示於ESG內頁，若要新增數量，請點擊下方 [添加] 按鈕
          </div>

          <!-- items -->
          <PageCollapse v-for="(item, i) in projectDetail.downloads" :key="i">
            <template v-slot:head>
              <h3 class="mr-auto">File {{ i + 1 }}</h3>
            </template>
            <template v-slot:actions>
              <div class="ml-auto">
                <button class="btn square mr-10px" @click="deleteFileItem(item)">
                  <v-icon class="ink-02-medium--text">delete</v-icon>
                </button>
                <button class="btn square mr-10px" @click="downFileItem(item, i)">
                  <v-icon class="ink-02-medium--text">arrow_downward</v-icon>
                </button>
                <button class="btn square" @click="upFileItem(item, i)">
                  <v-icon class="ink-02-medium--text">arrow_upward</v-icon>
                </button>
              </div>
            </template>
            <template v-slot:body>
              <!-- 顯示名稱 -->
              <label class="form-item d-flex pb-3">
                <h4 class="w-180px mt-5">顯示名稱</h4>
                <div class="flex-grow-1 mt-3">
                  <div class="form-input-group">
                    <input type="text" v-model="item.title" />
                  </div>
                </div>
              </label>
              <!-- 檔案 -->
              <div class="d-flex px-5 pt-5 mb-8">
                <div class="w-180px">
                  <h4 class="mb-10px">檔案上傳方式</h4>
                </div>
                <div class="flex-grow-1 flex-basis-0">
                  <v-radio-group v-model="item.uploadtype" row>
                    <v-radio
                      :value="0"
                      color="brand-600"
                      class="h-20px mr-5"
                    >
                      <template v-slot:label>
                        <div class="h5 ink-01-emphasis--text d-flex align-center w-192px">
                            Upload File
                        </div>
                      </template>
                    </v-radio>
                    <v-radio
                      :value="1"
                      color="brand-600"
                      class="h-20px"
                    >
                      <template v-slot:label>
                        <div class="h5 ink-01-emphasis--text d-flex align-center">
                          Link To
                        </div>
                      </template>
                    </v-radio>
                  </v-radio-group>
                </div>
              </div>
              <!-- 檔案連結 -->
              <label class="form-item d-flex pt-5" v-if="item.uploadtype == 1">
                <h4 class="w-160px mr-5">檔案連結</h4>
                <div class="flex-grow-1 my-3">
                  <div class="form-input-group">
                    <div class="prepend-icon" style="top: 45%;">
                      <v-icon>link</v-icon>
                    </div>
                    <input
                      type="text"
                      class="pl-42px"
                      style="top: 45%"
                      v-model="item.file"
                    />
                  </div>
                </div>
              </label>
              <!-- 檔案連結預覽圖 -->
              <div class="d-flex px-5 pt-5 mb-8" v-if="item.uploadtype == 0">
                <div class="w-180px">
                  <h4 class="mb-10px">檔案連結預覽圖</h4>
                  <div class="h5 ink-02-medium--text">
                    建議格式：.pdf <br />
                    檔案大小限制：≤ 5 MB
                  </div>
                </div>
                <div class="d-flex justify-end flex-grow-1">
                  <FileUploader
                    v-model="item.file_preview"
                    dir="csr"></FileUploader>
                </div>
              </div>
              <!-- 檔案 -->
              <div class="d-flex px-5 pt-5 mb-8" v-if="item.uploadtype == 0">
                <div class="w-180px">
                  <h4 class="mb-10px">檔案</h4>
                  <div class="h5 ink-02-medium--text">
                    建議格式：.pdf <br />
                    檔案大小限制：≤ 5 MB
                  </div>
                </div>
                <div class="d-flex justify-end flex-grow-1">
                  <FileUploader
                    v-model="item.file"
                    dir="csr"></FileUploader>
                </div>
              </div>
            </template>
          </PageCollapse>
          <!-- add files -->
          <div class="mt-5">
            <button
              class="btn btn-outlined w-100 justify-start"
              @click="addFileItem"
            >
              <v-icon class="primary--text mr-2">add_circle</v-icon>
              <span>添加</span>
            </button>
          </div>
        </div>
        <div class="page-actions">
          <v-spacer></v-spacer>
          <button class="btn mr-5" @click="cancelHandler">
            <span>取消</span>
          </button>
          <button class="btn btn-primary" @click="saveHandler">
            <span>儲存</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import ImgUploader from '@/components/ImgUploader.vue';
import ProjectFilterCreater from '@/views/B-4__CSRPage/c/B-4-1-2-1a-1__CSR-ProjectShowcasePageEdit_ProjectFilter-Create.vue';
import FileUploader from '@/components/FileUploader.vue';
import PageCollapse from '@/components/PageCollapse.vue';

export default {
  components: {
    ImgUploader,
    ProjectFilterCreater,
    FileUploader,
    PageCollapse,
  },
  data: () => ({
    isProjectFilterCreaterShow: false,
    tab: '',
  }),
  computed: {
    ...mapState('csr', ['csr', 'projectDetail', 'tabs']),
  },
  async created() {
    await this.getTabs();
  },
  methods: {
    ...mapActions('csr', [
      'getTabs',
      'setProjectDetail',
      'saveProject',
      'clear',
    ]),
    addItem() {
      const template = {
        title: '',
        description: '',
        visual: '',
      };
      this.projectDetail.content.push(template);
    },
    deleteItem(item) {
      const index = this.projectDetail.content.map((i) => i.id).indexOf(item.id);
      this.projectDetail.content.splice(index, 1);
    },
    cancelHandler() {
      this.$router.go(-1);
    },
    addFileItem() {
      const template = {
        title: '',
        file: '',
      };
      this.projectDetail.downloads.push(template);
    },
    deleteFileItem(item) {
      const index = this.projectDetail.downloads.map((i) => i.id).indexOf(item.id);
      this.projectDetail.downloads.splice(index, 1);
    },
    downFileItem(item, i) {
      if (i === this.projectDetail.downloads.length - 1) {
        this.projectDetail.downloads.splice(i, 1);
        this.projectDetail.downloads.unshift(item);
        return;
      }
      this.projectDetail.downloads.splice(i, 1);
      this.projectDetail.downloads.splice(i + 1, 0, item);
    },
    upFileItem(item, i) {
      if (i === 0) {
        this.projectDetail.downloads.splice(i, 1);
        this.projectDetail.downloads.push(item);
        return;
      }
      this.projectDetail.downloads.splice(i, 1);
      this.projectDetail.downloads.splice(i - 1, 0, item);
    },
    async saveHandler() {
      if (this.csr == null) {
        await this.saveProject(this.projectDetail).then(() => {
          this.clear();
        });
      } else {
        this.setProjectDetail(this.projectDetail);
      }
      this.$router.go(-1);
    },
  },
};
</script>

<style></style>
